export var TargetEntitiesExtractorServiceName = "TargetEntitiesExtractorService";
